<template>
  <v-system-bar
    app
    color="primary"
    dark
    height="32"
  >
    <v-spacer />

    <div
      v-if="!userIsAuthenticated"
      class="mr-3"
    >
      <v-icon class="mr-1">
        mdi-email
      </v-icon>
      <router-link
        to="/sign-up"
        tag="span"
        style="cursor:pointer"
      >
        Sign Up
      </router-link>
    </div>
    <div
      v-if="!userIsAuthenticated"
      class="mr-3"
    >
      <v-icon class="mr-1">
        mdi-human
      </v-icon>
      <router-link
        to="/sign-in"
        tag="span"
        style="cursor:pointer"
      >
        Sign In
      </router-link>
    </div>
    <div class="mr-3">
      <v-btn
        v-if="userIsAuthenticated"
        text
        @click="onLogout"
      >
        <v-icon class="mr-1">
          mdi-logout
        </v-icon>
        Sign Out
      </v-btn>
    </div>
  </v-system-bar>
</template>

<script>
  export default {
    computed: {
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    },
    methods: {
      onLogout () {
        this.$store.dispatch('signout')
      }
    }
  }
</script>
